// Mock data for SolarBull website

export const services = [
  {
    id: 1,
    title: "Industrial Solar Power Projects",
    description: "Trusted EPC partner for industrial solar power plants, delivering high-performance systems with predictable savings and attractive payback periods.",
    icon: "factory",
    features: ["Captive Solar Power Plants", "Net Metering Solutions", "CAPEX / Lease / PPA Models", "3-5 Year Payback Period"],
    details: "We develop Net Metering / Behind-the-Meter captive solar plants for industries, typically achieving a 3–5 year payback period. Each project is structured to align with the client's financial strategy, power demand, and sustainability objectives."
  },
  {
    id: 2,
    title: "Commercial Solar Power Projects",
    description: "Complete rooftop solar solutions for educational institutions, hospitals, offices, retail stores, warehouses, and commercial establishments.",
    icon: "building",
    features: ["Site Survey & Feasibility", "Custom Design & Engineering", "Net Metering & Approvals", "Commissioning & Handover"],
    details: "Serving educational institutions, hospitals, offices, shopping malls, automobile showrooms, warehouses, cold storages, Petrol Pumps, Places of worship, Function Halls and logistics parks with optimal system performance, safety, and long-term reliability."
  },
  {
    id: 3,
    title: "Residential Solar Solutions",
    description: "Complete rooftop solar installations for homes with customized designs, premium quality panels, and government subsidy support.",
    icon: "home",
    features: ["Rooftop Installation", "Net Metering", "Government Subsidy", "30-Year Warranty"],
    details: "Residential solar systems with up to ₹78,000 subsidy available. Professional installation with high-efficiency panels and comprehensive maintenance support."
  },
  {
    id: 4,
    title: "PM SURYA GHAR: Muft Bijli Yojana",
    description: "Government of India initiative for rooftop solar with subsidies up to 40%. Generate your own electricity, reduce bills, and contribute to a cleaner environment.",
    icon: "sun",
    features: ["Rs.30,000 for 1 KW, Rs.60,000 for 2 KW and Rs.78,000 for 3 KW and above: for domestic consumers", "Direct Bank Credit of Subsidy", "Net Metering Facility", "Bank Loan/ EMI Facility available"],
    details: "Massive savings on electricity bills with payback in 3-5 years. Protection against future tariff hikes, 25+ years of clean power, and increased property value. Online transparent application process for residential homeowners with adequate rooftop space."
  },
  {
    id: 5,
    title: "Open Access Solar Power Projects",
    description: "Develop and support Open Access solar projects for large C&I consumers seeking long-term green power at competitive tariffs.",
    icon: "zap",
    features: ["100% Captive Solar", "Group Captive Solar", "Third-Party Power Sale", "Regulatory Compliance"],
    details: "Complete feasibility analysis, commercial modeling, EPC execution, and Open Access approvals with scheduling and compliance support."
  },
  {
    id: 6,
    title: "PM-KUSUM Solar Projects",
    description: "Turnkey EPC and EPCM services for PM-KUSUM ground-mounted solar power projects under Component-A and Component-C.",
    icon: "tractor",
    features: ["Component A & C – Ground Mounted Solar", "25-Year Cash Flows", "Turnkey EPC / EPCM Solutions", "Government Approvals", "Bank Loan Support"],
    details: "Complete engineering, procurement, construction, government approvals, DISCOM coordination, and testing & commissioning for PM-KUSUM projects."
  },
  {
    id: 7,
    title: "Solar O&M Services",
    description: "Comprehensive operations and maintenance services to ensure maximum generation and long-term asset performance.",
    icon: "wrench",
    features: ["Preventive Maintenance", "Generation Monitoring", "Performance Tracking", "Compliance Support"],
    details: "Daily generation monitoring, PR tracking, fault detection & rectification, module cleaning, and documentation support with annual contracts available."
  },
  {
    id: 8,
    title: "Solar PMC & Consultancy",
    description: "Independent solar engineering and project management consultancy for developers, investors, institutions, and industries.",
    icon: "clipboard",
    features: ["DPR Preparation", "Project Management", "Owner's Engineer Services", "Regulatory Advisory", "Due Diligence Services"],
    details: "Basic and detailed engineering, PMC services, technical due diligence, and comprehensive policy and statutory advisory support."
  }
];

export const projects = [
  {
    id: 1,
    title: "VST Industries",
    location: "Hyderabad",
    state: "Telangana",
    capacity: "883 kW",
    type: "Industrial",
    completionDate: "2023",
    image: "/images/VST_Industries_883kWp.jpg",
    description: "Large-scale rooftop solar installation for VST Industries with complete EPC solution.",
    savingsPerYear: "₹79,47,000"
  },
  {
    id: 2,
    title: "E-City TSIIC",
    location: "Hyderabad",
    state: "Telangana",
    capacity: "1.5 MW",
    type: "Industrial",
    completionDate: "2022",
    image: "/images/E-City_TSIIC_1.5MW.jpg",
    description: "Ground-mounted solar power plant for TSIIC E-City industrial park.",
    savingsPerYear: "₹1,35,00,000"
  },
  {
    id: 3,
    title: "Sudhakar Plastics",
    location: "Suryapet",
    state: "Telangana",
    capacity: "1 MW",
    type: "Industrial",
    completionDate: "2023",
    image: "/images/Sudhakar_Plastics_1MW.jpg",
    description: "Captive solar power plant for PVC manufacturing facility with net metering.",
    savingsPerYear: "₹90,00,000"
  },
  {
    id: 4,
    title: "Suven Pharmaceuticals (Cohance Life Sciences)",
    location: "Hyderabad",
    state: "Telangana",
    capacity: "867 kW",
    type: "Industrial",
    completionDate: "2022",
    image: "/images/Suven_Pharma_867kWp.jpg",
    description: "Rooftop solar installation for pharmaceutical manufacturing facility.",
    savingsPerYear: "₹78,03,000"
  },
  {
    id: 5,
    title: "Casper Pharma (Cohance Life Sciences)",
    location: "Shamshabad",
    state: "Telangana",
    capacity: "750 kW",
    completionDate: "2023",
    image: "/images/Casper_Pharma_750kWp.jpg",
    description: "Comprehensive solar EPC solution for pharmaceutical manufacturing unit.",
    savingsPerYear: "₹67,50,000"
  },
  {
    id: 6,
    title: "Singhania Foods International",
    location: "Medchal",
    state: "Telangana",
    capacity: "375 kW",
    type: "Industrial",
    completionDate: "2023",
    image: "/images/Singhania_Foods_600kWp.jpg",
    description: "Solar power plant for food processing facility with energy optimization.",
    savingsPerYear: "₹54,00,000"
  },
  {
    id: 7,
    title: "Paragon Consumer Care",
    location: "Hyderabad",
    state: "Telangana",
    capacity: "200 kW",
    type: "Industrial",
    completionDate: "2023",
    image: "/images/Paragon_Consumer_Care_200kWp.jpg",
    description: "Solar EPC solution for consumer goods manufacturing facility.",
    savingsPerYear: "₹18,00,000"
  },
  {
    id: 8,
    title: "Savera Pipes",
    location: "Mulugu",
    state: "Telangana",
    capacity: "255 kW",
    type: "Industrial",
    completionDate: "2023",
    image: "/images/Savera_Pipes_268kWp.jpg",
    description: "Rooftop solar installation for pipe manufacturing facility.",
    savingsPerYear: "₹24,12,000"
  },
  {
    id: 9,
    title: "Bio Pharma Labs",
    location: "Bollaram",
    state: "Telangana",
    capacity: "164 kW",
    type: "Industrial",
    completionDate: "2023",
    image: "/images/Bio_Pharma_Labs_164kWp.jpg",
    description: "Ground-mounted solar power plant for pharmaceutical laboratory.",
    savingsPerYear: "₹14,76,000"
  },
  {
    id: 10,
    title: "Sibelco India Minerals",
    location: "Burugula, Mehabubnagar",
    state: "Telangana",
    capacity: "500 kW",
    type: "Industrial",
    completionDate: "2024",
    image: "/images/Sibelco_4.jpg",
    description: "Industrial solar power plant for mineral processing facility.",
    savingsPerYear: "₹45,00,000"
  },
  {
    id: 11,
    title: "Shri RK Modern Rice Mills",
    location: "Nizamabad",
    state: "Telangana",
    capacity: "1 MW",
    type: "Industrial",
    completionDate: "2025",
    image: "/images/Sri_RK_Rice_Mill_1MW.jpg",
    description: "Large-scale 1 MW solar power plant for rice mill with complete EPC solution.",
    savingsPerYear: "₹90,00,000"
  },
  {
    id: 12,
    title: "Fresh Living Apartments (Residential Society",
    location: "Madhapur, Hyderabad",
    state: "Telangana",
    capacity: "132 kW",
    completionDate: "2023",
    image: "/images/Fresh_Living_Apartments_132kWp.jpg",
    description: "Rooftop solar installation for residential apartment complex.",
    savingsPerYear: "₹11,88,000"
  },
  {
    id: 13,
    title: "Bollineni Homes (Residential Society",
    location: "Madhapur, Hyderabad",
    state: "Telangana",
    capacity: "50 kW",
    type: "Residential",
    completionDate: "2022",
    image: "/images/Bollineni_Homes_50kWp.jpg",
    description: "Residential complex solar installation with modern monitoring system.",
    savingsPerYear: "₹4,50,000"
  },
  {
    id: 14,
    title: "Vasavi College of Engineering",
    location: "Hyderabad",
    state: "Telangana",
    capacity: "75 kW",
    type: "Commercial",
    completionDate: "2022",
    image: "/images/Vasavi_College_75kWp.jpg",
    description: "Educational institution solar installation with net metering facility.",
    savingsPerYear: "₹6,75,000"
  },
  {
    id: 15,
    title: "St Peters School",
    location: "Hyderabad",
    state: "Telangana",
    capacity: "70 kW",
    type: "Commercial",
    completionDate: "2022",
    image: "/images/St_Peters_School_70kWp.jpg",
    description: "Rooftop solar system for educational institution reducing operational costs.",
    savingsPerYear: "₹6,30,000"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Gurung",
    designation: "Business Owner",
    location: "Hyderabad",
    rating: 5,
    text: "Solar Bull Energy LLP provided excellent installation and support. Their team sanju engineer was very professional and completed our rooftop solar project on time with top-quality workmanship.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh",
    source: "Google Review",
    date: "3 months ago"
  },
  {
    id: 2,
    name: "Ramesh Vuriti",
    designation: "Dukes Group",
    location: "Hyderabad",
    rating: 5,
    text: "We have opted Solarbull Energy LLP for establishing 2000 KW of Solar system at our industries (Dukes Group). They are very prompt in completing the project, very competitive, immediate service.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ramesh",
    source: "Google Review",
    date: "2 years ago"
  },
  {
    id: 3,
    name: "Sony Sangepagu",
    designation: "Customer",
    location: "Hyderabad",
    rating: 5,
    text: "Excellent service from start to finish. The team explained the entire solar installation process clearly and helped us understand the government subsidy as well. The installation was completed on time and the system is working perfectly. Our electricity bill has reduced significantly. Highly recommend this company for rooftop solar.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sony",
    source: "Google Review",
    date: "a week ago"
  }
];

export const team = [
  {
    id: 1,
    name: "Srinivas Kukkadapu",
    designation: "CEO & Partner",
    bio: "24+ years of professional experience across renewable energy, power, telecom, and chemicals sectors. Directly associated with execution of 375+ MW of solar EPC projects.",
    description: "His core expertise includes solar project execution, financial structuring, regulatory compliance, Open Access and captive power frameworks, and strategic business growth. As CEO, he provides overall leadership and direction, ensuring SolarBull delivers technically sound, commercially viable, and scalable solar power solutions.",
    image: "/images/srinivas.jpg"
  },
  {
    id: 2,
    name: "Swaroopa Gupta",
    designation: "Partner & Co-Founder",
    bio: "Co-Founder leading client engagement, strategic planning, and business excellence initiatives at SolarBull Energy LLP.",
    description: "She plays a pivotal role in managing customer interfaces, aligning project outcomes with client expectations, and driving continuous improvement across internal processes. Her focus on end-to-end customer satisfaction, relationship management, and long-term value creation has been instrumental in building SolarBull's strong reputation among C&I solar customers.",
    image: "/images/swaroopa.jpg"
  },
  {
    id: 3,
    name: "Ravindranath Duddu",
    designation: "Technical Director",
    bio: "30+ years of engineering and project experience, heading technical and engineering functions at SolarBull Energy LLP.",
    description: "His expertise covers solar power plant design, engineering optimization, vendor qualification, quality assurance, and technical risk management. He ensures that all SolarBull projects adhere to best-in-class engineering standards, optimal performance benchmarks, and long-term reliability, enabling efficient and bankable solar project execution.",
    image: "/images/ravi.jpg"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is the cost of solar panel installation?",
    answer: "The cost of solar installation depends on the system capacity, application, and project requirements. Residential solar systems (1–10 kW) typically range from ₹60,000 to ₹5,00,000, depending on size and specifications. Commercial & Industrial (C&I) solar projects, including rooftop and ground-mounted systems, are priced based on capacity, load profile, structural conditions, and delivery model (CAPEX/OPEX/Open Access). Use our solar calculator or contact us for a quick, customized estimate."
  },
  {
    id: 2,
    question: "How much can I save on electricity bills?",
    answer: "As a simple rule of thumb, every 1 kW of solar capacity typically saves about ₹1,000 per month on your electricity bill. This translates to approximately ₹12,000 per kW per year. For example, a 5 kW residential solar system can save around ₹60,000 annually, depending on your electricity consumption and available sunlight hours."
  },
  {
    id: 3,
    question: "What is the payback period for solar investment?",
    answer: "Typically, the payback period is 3–5 years for domestic (residential) solar systems and 3–4 years for commercial and industrial solar systems, depending on electricity tariffs, system size, and consumption pattern. Indian Solar irradiation further supports faster returns on investment."
  },
  {
    id: 4,
    question: "Do you provide maintenance services?",
    answer: "Yes. We offer comprehensive O&M (Operation & Maintenance) services for all types of solar installations. Customers can choose AMC plans with solar module cleaning (regular cleaning, performance monitoring, preventive maintenance) or AMC plans without module cleaning, covering system health checks and performance monitoring. This flexibility allows customers to select the service model that best suits their site conditions and budget."
  },
  {
    id: 5,
    question: "Are there any government subsidies available?",
    answer: "Yes. Under the PM SURYA GHAR: Muft Bijli Yojana, the Government of India provides a central subsidy for residential rooftop solar systems, with financial assistance of Rs. 30,000 for 1 kW, Rs. 60,000 for 2 kW, and Rs. 78,000 for 3 kW and above. The subsidy is directly credited to the homeowner's bank account through Direct Benefit Transfer (DBT) after successful installation and commissioning, significantly reducing the upfront project cost and electricity bills."
  },
  {
    id: 6,
    question: "How long does installation take?",
    answer: "Residential installations typically take 1-4 weeks, commercial projects 2-16 weeks, and large industrial projects 8-20 weeks depending on capacity and complexity."
  }
];

export const stats = [
  { label: "MW+ Installed", value: "65", icon: "zap" },
  { label: "Happy Customers", value: "100", icon: "users" },
  { label: "Projects Completed", value: "150", icon: "award" },
  { label: "Years Experience", value: "9", icon: "calendar" }
];
